import React from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Services = () => {
  const services = [
    {
      title: "Car Loans",
      description:
        "Flexible financing for your dream car with competitive rates and up to 5-year repayment terms.",
    },
    {
      title: "Watch Loans",
      description:
        "Get quick loans to purchase luxury watches, tailored to your budget.",
    },
    {
      title: "Jewelry Loans",
      description:
        "Affordable loans for exquisite jewelry, with fast approvals and easy repayments.",
    },
  ];
  return (
    <Box sx={{ bgcolor: "grey.100", minHeight: "100vh", py: 8 }}>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Our Loan Services
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          paragraph
          align="center"
        >
          Explore our tailored loan options for cars, watches, and jewelry.
        </Typography>
        <Grid container spacing={4} sx={{ mt: 4 }}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {service.description}
                  </Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    component={RouterLink}
                    to="https://system.bunda.co.ke/apply"
                    sx={{ mt: 2 }}
                  >
                    Apply Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
